import * as React from "react";
import { SVGProps } from "react";

function SvgLogo(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="39px"
      height="48px"
      viewBox="0 0 39 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.018 25.132a1.878 1.878 0 0 0-3.756 0v3.314a1.878 1.878 0 1 0 3.756 0v-3.314ZM10.384 26.79a1.878 1.878 0 1 0-3.756 0v.22a1.878 1.878 0 1 0 3.756 0v-.22ZM21.652 19.277a1.878 1.878 0 1 0-3.756 0v15.135a1.878 1.878 0 1 0 3.756 0V19.277ZM27.397 14.03a1.933 1.933 0 1 0-3.866 0v25.63a1.933 1.933 0 0 0 3.866 0V14.03ZM33.031 19.498a1.878 1.878 0 0 0-3.756 0v14.693a1.878 1.878 0 1 0 3.756 0V19.498Z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0h38.665v9.887a1.878 1.878 0 0 1-3.756 0V3.756H3.756v40.488h31.153v-18.89a1.878 1.878 0 1 1 3.756 0V48H0V0Z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgLogo;
